import React, { useEffect, useState, useRef } from 'react';
import './solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase'; // adjust based on your structure

import { FaLinkedin } from 'react-icons/fa';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "",
    poster: "/images/birds.jpg",
    heading: "A Strong Network of Trusted Partnerships",
    subheading: "Where modern networks converge and tomorrow’s service delivery begins.",
    buttonLink: "https://www.youtube.com/watch?v=tbUjpfa86FY"
  }
];

const leadershipTeam = [
  {
    name: 'David Z. Chen, Ph.D.',
    title: 'Chief Technology Officer',
    image: '/images/leadership/david.jpg',
    linkedin: 'https://www.linkedin.com/in/david-z-chen-a1a0981/',
    bio: 'Dr. David Z. Chen joined Go!Foton in June, 2018 as Chief Technology Officer. David is a veteran of Verizon Communication Inc. (1995-2017). During his 23 years of service, David worked as a Computer Server Farm/Data-Center IT-manager, Verizon Corporate Advanced Technology Fellow and Distinguished Member of Technical Staff supporting the technology development/advancement of ULH, Metro and Access, and Verizon Passive Optical Component/System quality control manager. David has published many industry record breaking ULH field trial papers, and he has been granted numerous USA patents. At Verizon, he led the industry into the new Ultra-Bend-Insensitive fiber (G.657-B3) invention, improved new Dry-Filler based OSP cables, perfected Air-Jetted-Cable deployment for densely populated cities, contributed MDU drop to In-Living-Unit fiber cable design and related optical termination products. Jointly, David has been working with Telcordia and other industry leading optical fiber/system vendors in the multiple Telcordia GR based quality control/testing/standard documentation revisions. He also contributed to the industry on Space-Division-Multiplex technology development with multiple patents granted. David holds a BS degree in precision mechanics and optical instrument from Shanghai Science and Technology University, two Master and a Ph.D. degree in Theoretical Physics with the focus on Quantum/Nonlinear Optics, Modern Chaos theory, and computational analysis for quantum stability and Higgs Boson from University of Texas at Dallas.'
  },
  {
    name: 'Michael Zammit',
    title: 'VP & GM, Connectivity Solutions',
    image: '/images/leadership/mike.jpg',
    linkedin: 'https://www.linkedin.com/in/michael-zammit-2183812/',
    bio: 'Michael Zammit joined in February 2014 Vice President and General Manager at Go!Foton Corporation in Somerset, NJ where he is responsible for the Connectivity Business Unit. An engineer by training, Michael is an accomplished global business development and telecom management executive with a broad perspective for identifying and growing strategic business opportunities. Most recently, Michael was Managing Director of the Network & Product Integrity Group at Telcordia Technologies where his lab team was responsible for developing and publishing performance requirements and standards for passive optical components as well as related outside plant, access network products and technologies. Prior to Telcordia, Michael was a founding member and Vice President of Advanced Broadband, LLC; a division of Toll Brothers, Inc (NYSE: TOL) which provided private broadband services to luxury gated communities and MDUs nationwide before its acquisition by Comcast. While at Toll Brothers, Michael was responsible for all aspects of business operations including the design, engineering, and construction of CATV and datacom headends as well as HFC and FTTH distribution networks. Michael earned his BS and MS degrees in Mechanical Engineering from Columbia University and MIT, respectively.'
  },
  {
    name: 'Mark Miller',
    title: 'Vice President of Sales',
    image: '/images/leadership/mark.jpg',
    linkedin: 'https://www.linkedin.com/in/mark-miller-285aa62/',
    bio: 'Mark joined in April 2023 as Vice President of Sales based at Go!Foton’s headquarters in Somerset, NJ. He is responsible for Go!Foton’s overall sales operations. Mark brings a long history of sales experience to the Company after his 34 years of tenure at AT&T. He started as an engineer at AT&T after graduating from college and quickly moved to product management, then sales and business development. Prior to joining the Company, he retired from AT&T as a director of business development, leading collaborative efforts with AT&T sales teams and network architects targeting C-Suite executives at Fortune 500 companies. Mark holds a BS degree in Electrical Engineering from Rutgers University.'
  },
  {
    name: 'Timothy Badar',
    title: 'VP Product Line Management',
    image: '/images/leadership/tim.jpg',
    linkedin: 'https://www.linkedin.com/in/timothy-badar-15445828/',
    bio: 'Tim Badar joined Go!Foton as head of global Product Line Management in 2016 and was promoted to be Vice President of PLM in April, 2020. He is also interim GM of the Passive Optical Solutions Business Unit. Tim brings strong Telecom and Datacom network and market experience from his previous Product Management and Business Development roles at TE Connectivity in next generation high-speed I/O connectors, fiber optic connectivity products, and passive optical devices. Tim holds several patents and has contributed industry papers on fiber optic components, optical inspection systems, and fiber network architectures. Previously, Tim held leadership roles in product development, product management, and business development in optical data storage and optical sensor/inspection technologies at CyberOptics, Seagate Technology and 3M. Tim holds a BS degree in Physics from the University of Notre Dame, and an MS degree in Optics from the University of Rochester, and is currently based in Go!Foton’s San Jose, CA office.'
  },
  {
    name: 'Glenn Lu',
    title: 'Group VP, Global Manufacturing',
    image: '/images/leadership/glenn.jpg',
    linkedin: false,
    bio: 'Glenn Lu joined NSG America as Vice President of Engineering in 2002 after serving as a consultant for a year for new product development. He was promoted to be the President of NSG Micro Optics Philippines in 2008, which became GF Micro Optics Philippines through the management buyout in 2009. Prior to joining NSG, Glenn served as Vice President of manufacturing and later Vice President of Global Manufacturing Operations at Oplink Communications, Inc. He started his career in the US with E-Tek Dynamics, now part of Lumentum, first as an R&D Engineer, later Manufacturing Engineer, and Production manager. He also participated in the founding of Avanex, now which is a part of Lumentum. Early in his career in China, he was an assistant professor in Physics at Shanghai Jiao Tong University. Glenn received his BS in Applied Physics and M.S. in Fiber Optics from Shanghai JiaoTong University in Shanghai, China, and M.S. in Electrical Engineering from City College of New York of CUNY in New York City.'
  },
  {
    name: 'Feng Tian, Ph.D.',
    title: 'VP & GM, Active Products',
    image: '/images/leadership/feng.jpg',
    linkedin: false,
    bio: 'Dr. Feng Tian joined Go!Foton in October 2012 as Vice President and General Manager of Active Products at Go!Foton. Feng has more than 25 years of experience in fiber optic communications. Most recently he was leading technical marketing development at Sumitomo Electric Device Innovations. Prior to that, he was DMTS at Motorola responsible for GPON development after Motorola acquired Quantum Bridge Communications, a startup qualified by Verizon for BPON system, where he was the chief optical scientist. His earlier career in fiber optics includes working experience in various countries including Canada, Germany, France, and China. Feng earned his Ph.D and M.S. in Optical Fiber Communications from Beijing University of Posts and Telecommunications, and B.S. in Electrical Engineering from the University of Electronic Science and Technology of China in Chengdu, China.'
  },
  {name: 'simin', bio: 'Dr. Simin Cai joined NSG America as a Regional Sales Manager in January, 1998. He worked in various sales, marketing, and business development positions before being promoted to President and Chief Operating Officer in 2001, and later Chief Executive Officer in 2005. In 2007, he was promoted to be the General Manager for NSG Group’s telecommunication business worldwide. In 2009, he led a management buyout and founded Go!Foton Group. Prior to joining NSG, Simin had worked for a couple of start-up companies involved in optics and optical instrumentation and participated in the founding of Avanex, now part of Lumentum after several mergers and acquisitions. Simin started his career with China International Trust and Investment Corporation (CITIC) in 1988. Simin holds a BS degree in Applied Physics from Shanghai Jiao Tong University in Shanghai, China, a Master of Engineering degree in Engineering Optics and a Ph.D. degree in Physics, both from Stevens Institute of Technology in Hoboken, New Jersey.'}
];


function Leadership() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };
  window.addEventListener("resize", handleResize);
  console.log('isMobile?', isMobile)
  return () => window.removeEventListener("resize", handleResize);
}, []);

const [showBio, setShowBio] = useState(false)
const [activeBio, setActiveBio] = useState(false);

const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  'Cassettes',
  'Fiber Panels',
  'Frames',
];



  return (
    <div className="contact-page">
      <div className="curved-header-leadership" style={{ background: isMobile ? '#8CC540' : ''}}>
        <center><h1>Meet the Leadership team</h1></center>
      </div>

      {/* <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none" >
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg> */}

      <div className="solutions-section-centeredText" style={{ marginTop: isMobile ? 0 : 0, position: isMobile ? '' : 'absolute', zIndex: 999}}>
        <div className="solutions-section-centeredText-text-container">
          {/* <h2 className="solutions-section-centeredText-subheading">Meet the leadership team</h2> */}
          <p className="solution-section-centeredText-description">Our executive team brings decades of experiences in optics, photonics, network technology, product design, operations, and customer care together to inspire and lead.​</p>
        </div>
      </div>

      <div className="leadership-wrapper" style={{ marginTop: isMobile ? 0 : 100}}>
            <div className="ceo-section">
              <img src="/images/leadership/simin.jpg" alt="Simin" className="ceo-image" />
              <div className="ceo-info">
                <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: isMobile ? 'center' : 'flex-start',
                alignItems: 'center',
              }}
            >
                <h3 style={{ textAlign: isMobile ? 'center' : 'left'}}>Simin Cai, Ph.D.</h3>
                                <a href="https://www.linkedin.com/in/simin-cai-us/" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 10, marginTop: 4 }}>
                  <FaLinkedin color="#0072b1" />
                </a>
                </div>
                <p style={{ textAlign: isMobile ? 'center' : 'left'}}>Founder, President & CEO</p>
                <em>“The sky is the limit when imagining what’s possible and creating what’s next.”</em>
                <div className="ceo-links">
            <div className="executive-links" style={{ marginTop: 25, width: isMobile ? '90vw' : 90,}}>
              <a
                href="#"
                className="cta-button"
                style={{ marginTop: 10, color: 'white', textDecoration: 'none' }}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveBio(leadershipTeam[6]); // store the full person object
                }}
              >
                Bio
              </a>
            </div>
                  <a style={{ color: '#D94829', marginTop:20}} target="_blank" href="https://www.forbes.com/councils/forbesbusinesscouncil/2026/03/20/when-founders-need-to-get-out-of-their-own-way/">Read the latest article from Simin</a>
                </div>
              </div>
            </div>

      <div className="executives-grid">
        {leadershipTeam.filter(person => person.name.toLowerCase() !== 'simin').map((person, index) => (
          <div key={index} className="executive-card">
            <img src={person.image} alt={person.name} className="executive-img" />

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <h4>{person.name}</h4>
              {person.linkedin && (
                <a href={person.linkedin} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 10, marginTop: 4 }}>
                  <FaLinkedin color="#0072b1" />
                </a>
              )}
            </div>

            <p style={{ marginTop: -10 }}>{person.title}</p>

            <div className="executive-links" style={{ marginTop: 25}}>
              <a
                href="#"
                className="cta-button"
                style={{ marginTop: 10, color: 'white', textDecoration: 'none' }}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveBio(person); // store the full person object
                }}
              >
                Bio
              </a>
            </div>
          </div>
        ))}
      </div>

      </div>

      {/* ONE global modal outside the map */}
      {activeBio && (
        <div className="modal-overlay" onClick={() => setActiveBio(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setActiveBio(null)}>×</button>
            <h2>Executive Bio</h2>
            <p style={{ marginTop: 20}}>{activeBio.bio}</p>
          </div>
        </div>
      )}

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

    
  );
}

export default Leadership;
